import axios from 'axios'
import BaseModel from '@/models/BaseModel.js'

export default class KodeKegiatan extends BaseModel {
  fields =  {
    'code': {
      label: 'Kode Kegiatan',
      type: 'text',
      rules: 'required'
    },
    'name': {
      label: 'Program',
      type: 'text',
      rules: 'required'
    },
    'description': {
      label: 'Uraian',
      type: 'text',
      rules: 'required'
    },
    // 'budget': {
    //   label: 'Budget',
    //   type: 'price',
    //   rules: 'required'
    // },
    // 'parent_id': {
    //   type: 'enum',
    //   label: 'parent_id',
    //   rules: 'required',
    //   options: []
    // },
  }

  endpoint = process.env.VUE_APP_API_URL + 'kode-kegiatan'
}